export const books = [
  {
    img:
      "https://images-na.ssl-images-amazon.com/images/I/51bvlSFseeL._SX373_BO1,204,203,200_.jpg",
    title: "Hand Bookbinding: A Manual of Instruction",
    author: "Aldren A. Watson",
  },
  {
    img:
      "https://images-na.ssl-images-amazon.com/images/I/51bvlSFseeL._SX373_BO1,204,203,200_.jpg",
    title: "Hand Bookbinding: A Manual of Instruction",
    author: "Aldren A. Watson",
  },
  {
    img:
      "https://images-na.ssl-images-amazon.com/images/I/51bvlSFseeL._SX373_BO1,204,203,200_.jpg",
    title: "Hand Bookbinding: A Manual of Instruction",
    author: "Aldren A. Watson",
  },
  {
    img:
      "https://images-na.ssl-images-amazon.com/images/I/51bvlSFseeL._SX373_BO1,204,203,200_.jpg",
    title: "Hand Bookbinding: A Manual of Instruction",
    author: "Aldren A. Watson",
  },
  {
    img:
      "https://images-na.ssl-images-amazon.com/images/I/51bvlSFseeL._SX373_BO1,204,203,200_.jpg",
    title: "Hand Bookbinding: A Manual of Instruction",
    author: "Aldren A. Watson",
  },
  {
    img:
      "https://images-na.ssl-images-amazon.com/images/I/51bvlSFseeL._SX373_BO1,204,203,200_.jpg",
    title: "Hand Bookbinding: A Manual of Instruction",
    author: "Aldren A. Watson",
  },
  {
    img:
      "https://images-na.ssl-images-amazon.com/images/I/51bvlSFseeL._SX373_BO1,204,203,200_.jpg",
    title: "Hand Bookbinding: A Manual of Instruction",
    author: "Aldren A. Watson",
  },
  {
    img:
      "https://images-na.ssl-images-amazon.com/images/I/51bvlSFseeL._SX373_BO1,204,203,200_.jpg",
    title: "Hand Bookbinding: A Manual of Instruction",
    author: "Aldren A. Watson",
  },
  {
    img:
      "https://images-na.ssl-images-amazon.com/images/I/51bvlSFseeL._SX373_BO1,204,203,200_.jpg",
    title: "Hand Bookbinding: A Manual of Instruction",
    author: "Aldren A. Watson",
  },
  {
    img:
      "https://images-na.ssl-images-amazon.com/images/I/51bvlSFseeL._SX373_BO1,204,203,200_.jpg",
    title: "Hand Bookbinding: A Manual of Instruction",
    author: "Aldren A. Watson",
  },
  {
    img:
      "https://images-na.ssl-images-amazon.com/images/I/51bvlSFseeL._SX373_BO1,204,203,200_.jpg",
    title: "Hand Bookbinding: A Manual of Instruction",
    author: "Aldren A. Watson",
  },
  {
    img:
      "https://images-na.ssl-images-amazon.com/images/I/51bvlSFseeL._SX373_BO1,204,203,200_.jpg",
    title: "Hand Bookbinding: A Manual of Instruction",
    author: "Aldren A. Watson",
  },
  {
    img:
      "https://images-na.ssl-images-amazon.com/images/I/51bvlSFseeL._SX373_BO1,204,203,200_.jpg",
    title: "Hand Bookbinding: A Manual of Instruction",
    author: "Aldren A. Watson",
  },
  {
    img:
      "https://images-na.ssl-images-amazon.com/images/I/51bvlSFseeL._SX373_BO1,204,203,200_.jpg",
    title: "Hand Bookbinding: A Manual of Instruction",
    author: "Aldren A. Watson",
  },
];
